import React from 'react';
import {Link} from 'react-router-dom';
import {Input, List, Card, message } from 'antd';
import styled from 'styled-components';
import {actionSearch, echo, actionRecommend} from '../utils/service';

const {Search} = Input;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const SearchInput = styled(Search)`
  margin: 24px auto;
`

const ItemCover = styled.div`
  background: url(${props => props.source}) no-repeat top center;
  background-size: cover;
  height: 12em;
`

export default class IndexSearch extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
    }
  }

  componentDidMount() {
    this.fetchRecommend();
  }

  fetchRecommend = () => {
    actionRecommend()
      .then(({data}) => {
        this.setState({
          loading: false,
          data: data.data,
        }) 
      }).catch(err => {
        message.error(`服务器返回错误：${err.message}`);
        this.setState({
          loading: true,
        })
      })
  }

  handleSearch = value => {
    this.setState({
      loading: true,
    })
    actionSearch(value)
      .then(({data}) => {
        this.setState({
          loading: false,
          data: data.data,
        })
      }).catch(err => {
        message.error(`服务器错误: ${err.message}`);
        this.setState({
          loading: false,
          data: [],
        })
      })
  }

  renderItem = item => (
    <List.Item>
      <Link to={`/p/${item.biz}`}>
        <Card hoverable={true} cover={<ItemCover source={`${echo}${encodeURIComponent(item.avatar)}`} />}>
          <Card.Meta title={item.name} />
        </Card>
      </Link>
    </List.Item>
  )

  render() {
    const {data, loading = false} = this.state;
    return (
      <Container> 
        <SearchInput size="large" placeholder="搜索你想订阅的公众号" onSearch={this.handleSearch} enterButton  />
        <List loading={loading} dataSource={data} grid={{gutter: 24, column: 2, gl: 4, md: 4, sm: 3}} renderItem={this.renderItem} />
      </Container>   
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/IndexSearch.js